<template>
    <v-navigation-drawer v-model="dialog" temporary right fixed width="90%">
        <v-form name="form" @submit.prevent="save" lazy-validation>
            <v-toolbar dark color="primary" dense>
                <v-btn icon small dark @click.native="handleModal"><v-icon small>fas fa-times-circle</v-icon></v-btn>

                <v-toolbar-title class="text-body-1">Registrar nueva asistencia</v-toolbar-title>
                <v-spacer></v-spacer>

                <v-toolbar-items>
                    <v-btn class="danger" text type="submit" :disabled="asistencias.length === 0">
                    <v-icon class="mr-1">fas fa-save</v-icon>Guardar asistencia</v-btn>
                </v-toolbar-items>
            </v-toolbar>

            <v-container fluid>
                <v-row>
                    <v-col cols="12">
                        <div>
                            <v-row>
                                <v-col cols="9" sm="12" md="9">
                                    <v-text-field v-model="search" label="Buscar empleados" append-icon="fas fa-search"
                                    clearable filled dense class="mt-2 mb--2" hide-details>
                                </v-text-field>
                                </v-col>
                                <v-col cols="3" sm="12" md="3">
                                    <v-checkbox v-model="todos" label="Seleccionar todos" @click.prevent="selectAll"
                                        prepend-icon="fas fa-user-friends" hide-details color="success"></v-checkbox>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col v-for="(empleado) in filterEmployee" :key="empleado.id" cols="12" sm="6" md="4">
                                    <v-tooltip top :disabled="!empleado.asistioHoy">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-card v-bind="attrs" v-on="on" outlined
                                                class="employee-tile d-flex align-center px-3 py-2"
                                                :class="{ 'employee-tile--selected': isSelected(empleado.id), 'employee-tile--disabled': empleado.asistioHoy }">
                                                <v-avatar size="32" :color="isSelected(empleado.id) ? 'success' : 'grey lighten-2'" class="mr-3">
                                                    <v-icon dark size="16">fas fa-user-tie</v-icon>
                                                </v-avatar>
                                                <v-checkbox
                                                    v-model="asistencias"
                                                    :value="empleado.id"
                                                    :disabled="empleado.asistioHoy"
                                                    :color="empleado.asistioHoy ? 'grey' : 'success'"
                                                    hide-details
                                                    class="ma-0 pa-0 flex-grow-1">
                                                    <template v-slot:label>
                                                        <div>
                                                            <div class="employee-tile__name">{{ empleado.nombreCompleto }}</div>
                                                            <div v-if="empleado.asistioHoy" class="employee-tile__hint">Ya asistió hoy</div>
                                                        </div>
                                                    </template>
                                                </v-checkbox>
                                            </v-card>
                                        </template>
                                        <span>Ya registró asistencia hoy</span>
                                    </v-tooltip>
                                </v-col>
                            </v-row>
                        </div>
                    </v-col>
                </v-row>
                <small style="display: block; margin-top: 20px;">* Indica son campos requeridos</small>
            </v-container>
        </v-form>
    </v-navigation-drawer>
</template>

<script>
import asistenciaDataService from '@/service/empleado/asistenciaDataService';
import empleadoDataService from '@/service/empleado/empleadoDataService';
import { extractMessage } from '@/helpers/errorHelper';

export default {
    name: "NuevaAsistencia",
    props: {
        dialog: { default: false },
        handleModal: { type: Function },
        lstAsistencia: { type: Function }
    },
    created() {
        this.getEmpleados();
    },
    data() {
        return {
            empleados: [],
            asistencias: [],
            search: "",
            todos: false
        }
    },
    methods: {
        save() {
            if( this.asistencias.length > 0 ) {
                asistenciaDataService.create( this.asistencias ).then( response => {
                    if ( response.status === 200 || response.status === 201 ) {
                        this.handleModal();
                        this.lstAsistencia();
                        this.$swal.fire({ position: 'top-end', title: 'Asistencia creada', text: 'La asistencia se ha creado correctamente', icon: 'success', showConfirmButton: false, timer: 2000 })
                    }
                }).catch( err => {
                    this.$swal.fire({
                        position: 'top-end', title: 'Error, Asistencia no registrada', text: extractMessage(err),
                        icon: 'error', showConfirmButton: false, timer: 2000
                    });
                });
            }
        },
        async getEmpleados() {
            this.empleados = await empleadoDataService.allWithoutAssistance().then( resp => resp.data ) || [];
        },
        selectAll() {
            if ( this.todos ) {
                this.asistencias = this.empleados.filter( item => !item.asistioHoy ).map( item => item.id );
            } else {
                this.asistencias = [];
            }
        },
        isSelected(empleadoId) {
            return this.asistencias.includes(empleadoId);
        }
    },
    computed: {
        filterEmployee() {
            if (this.search == '') return this.empleados;

            return this.empleados.filter((item) => {
                return item.nombreCompleto.toLowerCase().includes(this.search.toLowerCase())
            })
        }
    },
}
</script>

<style scoped>
.employee-tile {
    border-radius: 12px;
    transition: border-color 0.15s ease, background-color 0.15s ease, box-shadow 0.15s ease;
}
.employee-tile:hover:not(.employee-tile--disabled) {
    border-color: var(--v-success-base);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.employee-tile--selected {
    border-color: var(--v-success-base);
    background-color: rgba(76, 175, 80, 0.08);
    box-shadow: 0 2px 6px rgba(76, 175, 80, 0.25);
}
.employee-tile--disabled {
    opacity: 0.55;
}
.employee-tile__name {
    font-size: 0.9rem;
    font-weight: 500;
}
.employee-tile__hint {
    font-size: 0.75rem;
    color: #9e9e9e;
}
</style>
